import { useTheme } from '@mui/material';
import React from 'react';

interface IProps {
  size: number;
  color?: string;
}

export const ExternalLinkIcon = ({ size, color }: IProps) => {
  const theme = useTheme();
  return (
    <svg id="externallinkicon__assets-icons-v2__svg__l12"
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color ? color : theme.palette.common.black}
    strokeWidth={1.5}
    strokeLinecap="round"
    strokeLinejoin="round"
    className="icon icon-tabler icons-tabler-outline icon-tabler-external-link">
      
      <path id="externallinkicon__assets-icons-v2__path__l24" stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path id="externallinkicon__assets-icons-v2__path__l25" d="M12 6h-6a2 2 0 0 0 -2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-6" />
      <path id="externallinkicon__assets-icons-v2__path__l26" d="M11 13l9 -9" />
      <path id="externallinkicon__assets-icons-v2__path__l27" d="M15 4h5v5" />
    </svg>);

};